import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleEyesYeux1 = customSolarIconWrapper(<g transform="translate(93 117.5)">
	<path d="M53.0547 6.60544C53.8147 10.9521 50.9377 15.0971 46.6287 15.8636C42.3196 16.63 38.2105 13.7276 37.4508 9.38093C36.691 5.03423 39.5681 0.889237 43.8771 0.122737C48.1857 -0.643663 52.2947 2.25874 53.0547 6.60544Z" fill="#202020" />
	<path d="M15.7258 10.7116C16.4856 15.0583 13.6085 19.2033 9.29949 19.9697C4.99049 20.7362 0.881487 17.8338 0.121687 13.4871C-0.638113 9.14045 2.23909 4.99534 6.54799 4.22894C10.857 3.46254 14.9661 6.36484 15.7258 10.7116Z" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleEyesYeux1;
